import { Button, Flex, IconTrash } from '@vtex/admin-ui'
import { FormState, Select, TextInput } from '@vtex/admin-ui-form'
import { FormattedMessage, useIntl } from 'react-intl'
import { messages } from '../messages'
import styles from '../styles'

const editorMessages = messages.editor.zipCodeRangeEditor

interface Props {
  name: string
  state: FormState
  onRemove: () => void
}

export function Range(props: Props) {
  const { name, onRemove, state: form } = props
  const { $t } = useIntl()

  return (
    <Flex
      direction="row"
      key={name}
      className={styles.editor.range}
      data-testid="zip-code-range"
    >
      <FormattedMessage
        {...editorMessages.statement}
        values={{
          operator: (
            <Select
              name={`${name}.operator`}
              state={form}
              aria-label={$t(editorMessages.operator.label)}
            >
              <option value="include">
                <FormattedMessage {...editorMessages.operator.include} />
              </option>
              <option value="exclude">
                <FormattedMessage {...editorMessages.operator.exclude} />
              </option>
            </Select>
          ),
          from: (
            <TextInput
              name={`${name}.from`}
              state={form}
              aria-label={$t(editorMessages.range.from)}
            />
          ),
          to: (
            <TextInput
              name={`${name}.to`}
              state={form}
              aria-label={$t(editorMessages.range.to)}
            />
          ),
        }}
      />
      <Button
        variant="neutralTertiary"
        size="large"
        className={styles.editor.removeButton}
        icon={<IconTrash />}
        aria-label={$t(editorMessages.range.remove)}
        onClick={onRemove}
      />
    </Flex>
  )
}
